// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAS6SZbJTD0nFUKSwL2QaW_RUx4mc13xqo",
  authDomain: "chugchug-fcfe0.firebaseapp.com",
  projectId: "chugchug-fcfe0",
  storageBucket: "chugchug-fcfe0.appspot.com",
  messagingSenderId: "553736772266",
  appId: "1:553736772266:web:441d3fd807471923488ed3",
  measurementId: "G-RGWK179ZY9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);
